import React, { useContext } from "react"

const  PdfContext = React.createContext(false);
const usePdfType = () => {

    return useContext(PdfContext);
}

// create and export the AuthProvider - this is imported to the _app.js file
// and wrapped around the whole app, providing context to the whole app, and
// is called each time this specific context is accessed (updated or retrieved)
const PdfContextProvider = ({ pdfType,  children }) => <PdfContext.Provider value={pdfType}>
            {children}
        </PdfContext.Provider>;
export { PdfContextProvider, usePdfType };